import ShiftDeclinedReason from "@/models/Shared/ShiftDeclinedReason";

export default class AnonBookedReplyDto {
    bookingRoleWorkerShiftId = '';
	confirmed:   boolean;
	declinedReason: ShiftDeclinedReason = ShiftDeclinedReason.BOOKING_DECLINED_REASON_UNDEFINED;
}